import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const reviewLink = (id) => `${window.location.origin}/spalator/${id}?recenzie=1`;

export const QrDialog = ({ washer, open, onOpenChange }) => {
  const wrap = useRef(null);
  if (!washer) return null;
  const download = () => {
    const canvas = wrap.current.querySelector("canvas");
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `qr-${washer.name.toLowerCase().replace(/\s+/g, "-")}.png`;
    a.click();
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm border-white/10 bg-[#131B26]" data-testid="qr-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Cod QR – {washer.name}</DialogTitle>
          <DialogDescription>Clientul scanează și ajunge direct la recenzie.</DialogDescription>
        </DialogHeader>
        <div ref={wrap} className="mx-auto rounded-2xl bg-white p-4" data-testid="qr-code">
          <QRCodeCanvas value={reviewLink(washer.id)} size={512} style={{ width: 240, height: 240 }}
            marginSize={2} level="M" />
        </div>
        <p className="break-all text-center text-xs text-slate-500" data-testid="qr-link">{reviewLink(washer.id)}</p>
        <button onClick={download} data-testid="washer-qr-download-btn"
          className="flex w-full items-center justify-center gap-2 rounded-full bg-[#00F0FF] py-3 font-semibold text-[#090E17] transition-colors hover:bg-[#33F3FF]">
          <Download size={18} /> Descarcă Cod QR
        </button>
      </DialogContent>
    </Dialog>
  );
};
